export default "__VITE_ASSET__D0oz5QNn__"